module.exports = __webpack_public_path__ + "img/emoji_25.6218fbdb.png";